module.exports = __webpack_public_path__ + "static/media/km.0f12d30c.svg";